// The properties the promo_code_* events carry (ANALYTICS.md "Promo &
// referral code lifecycle", 26 Oct 2026). Imports nothing, so node --test
// can run it (code-props.test.mjs).
//
// Never a referral or reward code: a referral code starts with its owner's
// first name, so those go by code_id only. A credit or percent code is one
// made in the admin for a campaign, and is sent as typed (lower case).
// A code nobody recognised is not sent at all: it could be anything.

const CAMPAIGN = ['credit', 'percent']

// The server's one-word refusals (PromoCode::REFUSAL_REASONS), plus
// not_checked: the check never answered (network, a non-JSON reply).
export const REFUSALS = ['not_found', 'disabled', 'not_started', 'expired', 'used_up', 'already_used', 'min_basket',
  'own_code', 'existing_customer', 'already_referred', 'cross_referral', 'not_checked', 'unknown']

// referral | reward | percent | credit, as the server says; older payloads
// without code_type are told apart by their class name.
export const codeType = info => {
  if (!info) return null
  if (info.code_type) return info.code_type
  if (!info.type) return null
  return /^PercentPromoCode/.test(info.type) ? 'percent' : 'credit'
}

export const codeProps = info => {
  const type = codeType(info)
  if (!type) return {}
  const props = { code_type: type }
  if (info.code_id) props.code_id = info.code_id
  if (CAMPAIGN.includes(type) && info.code) props.code = String(info.code).trim().toLowerCase().slice(0, 64)
  if (info.value != null) {
    if (type === 'percent') props.percent = Number(info.value) || 0
    else props.value_pence = Math.round(Number(info.value) * 100) || 0
  }
  if (info.min_basket) props.min_basket_pence = Math.round(Number(info.min_basket) * 100)
  return props
}

export const refusalReason = data => (REFUSALS.includes(data?.refusal) ? data.refusal : 'unknown')

// What the page showed at a pay press that took the code off, and what it
// shows after: the washes less the code's money off, then the washes.
export const removedTotals = (info, basketPence, creditPence) => {
  if (!basketPence) return {}
  const off = codeType(info) === 'percent'
    ? Math.round(basketPence * (Number(info.value) || 0) / 100)
    : creditPence
  return { total_from_pence: Math.max(0, basketPence - (off || 0)), total_to_pence: basketPence }
}
